import { Grid, Typography } from "@mui/material";

import { formatDecimal } from "@aclymatepackages/formatters";

import TransportationMethodOptions from "../TransportationMethodOptions";

import useProductsEmissionsFactors from "../../../helpers/contexts/ProductsEmissionsFactors";

const ProductRouteTransportationMethodOptions = ({
  leg,
  editLeg,
  disabled,
  footprintShared
}) => {
  const { transportationMethod, footprintKgs } = leg || {};

  const [{ isSubscribed }] = useProductsEmissionsFactors();
  return (
    <>
      <Grid container direction="column" alignItems="center">
        <Grid item>
          <TransportationMethodOptions
            value={transportationMethod}
            onChange={editLeg}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      {!isNaN(footprintKgs) && (
        <Typography
          variant="caption"
          color="textSecondary"
          display="block"
          align="center"
        >
          Footprint:{" "}
          {isSubscribed || footprintShared ? (
            formatDecimal(footprintKgs)
          ) : (
            <span style={{ filter: "blur(4px)" }}>####</span>
          )}{" "}
          kgs CO2e
        </Typography>
      )}
    </>
  );
};
export default ProductRouteTransportationMethodOptions;
